<!--
 * @Description: 所有需求
 * @Author: PF
 * @Date: 2023-12-19 10:06:30
 * @LastEditors: PF
 * @LastEditTime: 2026-10-13 14:37:03
-->
<template>
  <el-container class="hp100 xuqiu-page">
    <!-- 左侧菜单树：支持展开 / 收起 -->
    <el-aside class="xuqiu-aside" :width="menuCollapsed ? '0px' : '220px'">
      <div class="aside-inner">
        <div class="aside-head">
          <span class="aside-title">
            <el-icon><Menu /></el-icon>需求菜单
          </span>
          <el-tooltip content="收起菜单" placement="right" :show-after="300">
            <el-button link class="fold-btn" @click="menuCollapsed = true">
              <el-icon><Fold /></el-icon>
            </el-button>
          </el-tooltip>
        </div>
        <div class="aside-body">
          <el-input v-model="filterText" class="tree-search" placeholder="搜索菜单名称" clearable :prefix-icon="Search" />
          <el-scrollbar class="tree-scroll" always>
            <el-tree
              ref="treeRef"
              node-key="id"
              :data="cdData"
              :props="treeProps"
              :default-expanded-keys="expandedKeys"
              :default-checked-keys="[dataGrid.parms.menuid]"
              highlight-current
              :expand-on-click-node="false"
              :filter-node-method="filterNode"
              @node-click="handleNodeClick"
              @node-expand="handleNodeClick"
            >
              <template #default="{ data }">
                <span class="tree-node">
                  <el-icon class="node-icon">
                    <Folder v-if="data.children && data.children.length" />
                    <Document v-else />
                  </el-icon>
                  <span class="node-label">{{ data.cdmc }}</span>
                </span>
              </template>
            </el-tree>
          </el-scrollbar>
        </div>
      </div>
    </el-aside>

    <el-main class="list-page pl10">
      <el-container class="hp100">
        <el-header class="list-head">
          <!-- 搜索区域 BEGIN -->
           <div class="mb10" style="display: flex;align-items: center;">
              <el-input v-model="dataGrid.parms.bt" class="w220 mr8" placeholder="标题关键字" clearable :prefix-icon="Search" @clear="bindTable()" @keyup.enter="bindTable()" />
              <el-select v-model="dataGrid.parms.lx" class="w150 mr8" placeholder="需求类型" clearable filterable @change="bindTable()">
                <el-option v-for="item in xqlxData.list" :key="item.value" :label="item.name" :value="item.value" />
              </el-select>
              <span class="mr8">解决状态</span>
              <el-radio-group v-model="dataGrid.parms.jjzt" @change="bindTable()">
                <el-radio v-for="item in jjztData.list" :key="item.value" :value="item.value">{{ item.name }}</el-radio>
              </el-radio-group>
              <el-link type="primary" :underline="false" class="ml8" @click="resetSearch()">
                <el-icon class="mr2"><RefreshLeft /></el-icon>查看全部
              </el-link>
          </div>
          <!-- 搜索区域 END -->

          <!-- 按钮区域 BEGIN -->
          <div class="mb10">
            <el-tooltip v-if="menuCollapsed" content="展开菜单" placement="bottom" :show-after="300" style="width: 35px;">
              <el-button circle :icon="Expand" @click="menuCollapsed = false" />
            </el-tooltip>
            <el-button type="primary" :icon="Plus" @click="openAdd = true">添加</el-button>
            <el-button type="warning" :icon="Delete" :disabled="!dataGrid.multipleSelection.length" @click="remove()">
              批量删除<span v-if="dataGrid.multipleSelection.length">({{ dataGrid.multipleSelection.length }})</span>
            </el-button>
          </div>
          <!-- 按钮区域 END -->
        </el-header>

        <el-main class="list-body">
          <el-table
            :data="dataGrid.data"
            :default-sort="dataGrid.orderBy"
            v-loading="dataGrid.loading"
            empty-text="暂无需求数据"
            height="100%"
            border
            stripe
            highlight-current-row
            @sort-change="dataGrid.sortChange"
            @selection-change="dataGrid.selectionChange"
          >
            <!-- 冻结列-Left BEGIN -->
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column label="序号" type="index" :index="indexMethod" width="60" fixed align="center" />
            <!-- 冻结列-Left END -->
            <el-table-column label="标题" prop="bt" min-width="250" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
              <template #default="scope">
                <span class="link-title" @click="openDetail = true; row = scope.row">{{ scope.row.bt }}</span>
              </template>
            </el-table-column>
            <el-table-column label="所属菜单" min-width="250" align="center" show-overflow-tooltip>
              <template #default="scope">
                <span v-if="scope.row.sscdlj">{{ scope.row.sscdlj + '-' + scope.row.menuMc }}</span>
                <span v-else-if="scope.row.xtmc && !scope.row.menuMc">{{ scope.row.xtmc }}-首页</span>
                <span v-else-if="!scope.row.xtmc && !scope.row.menuMc">首页</span>
              </template>
            </el-table-column>
            <el-table-column label="类型" prop="lx.name" width="90" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
              <template #default="scope">
                <el-tag v-if="scope.row.lx && scope.row.lx.name" size="small" effect="plain">{{ scope.row.lx.name }}</el-tag>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="提出人" prop="tcr" width="100" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="提出时间" prop="tcsj" width="150" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="解决人" prop="jjr" width="120" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
              <template #default="scope">
                <span>{{ scope.row.jjr || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="解决时间" prop="jjsj" width="150" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
              <template #default="scope">
                <span>{{ scope.row.jjsj || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="解决状态" prop="jjzt.name" width="110" align="center" show-overflow-tooltip>
              <template #default="scope">
                <el-tag v-if="scope.row.jjzt" size="small" :type="statusType(scope.row.jjzt.value)" effect="light">
                  {{ scope.row.jjzt.name }}
                </el-tag>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <!-- 冻结列-Right BEGIN -->
            <el-table-column label="操作" width="176" fixed="right" align="center">
              <template #default="scope">
                <el-button link type="primary" v-if="scope.row.jjzt && scope.row.jjzt.value === 0" @click="toFenPei(scope.row)">分配</el-button>
                <el-button link type="primary" v-if="scope.row.jjzt && scope.row.jjzt.value === unsolvedValue" @click="toKaiShi(scope.row)">开始</el-button>
                <el-button link type="primary" v-if="scope.row.jjzt && scope.row.jjzt.value === 2" @click="toJieJue(scope.row)">解决</el-button>
                <el-button link type="primary" @click="openEdit = true; row = scope.row">修改</el-button>
                <el-button link type="warning" @click="dataGrid.multipleSelection = [scope.row.id]; remove()">删除</el-button>
              </template>
            </el-table-column>
            <!-- 冻结列-Right END -->
          </el-table>
        </el-main>
        <el-footer>
          <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
        </el-footer>
      </el-container>
    </el-main>
  </el-container>

  <edit v-if="openEdit" v-model:openEdit="openEdit" :row="row" @ReturnData="bindTable" />
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />

  <el-dialog v-model="openAdd" title="添加" class="wp93 hp93" :before-close="handleClose">
    <add :indRow="addRow" @ReturnData="handleClose" />
  </el-dialog>
</template>

<script setup>
import { ref, computed, watch, nextTick } from 'vue'
import { loadList, loadSelect, actionPost, actionPatch, submitDataGridAction } from '@/api/common.js'
import { getDate } from '@/utils/index.js'
import { successPrompt, warningPrompt, errorPrompt } from '@/utils/promptInfo.js'
import { Search, RefreshLeft, Plus, Delete, Fold, Expand, Menu, Folder, Document } from '@element-plus/icons-vue'
import pagination from '@/components/pagination.vue'
import { ElMessageBox } from 'element-plus'
import edit from './edit.vue'
import detail from './detail.vue'
import add from './add.vue'

// 需求类型
const xqlxData = ref({ list: [] })
loadSelect({ url: '/api/v2/sys/xuqiu/xuqiuleixing', data: xqlxData })
// 解决状态
const jjztData = ref({ list: [] })
loadSelect({ url: '/api/v2/sys/xuqiu/jiejuezhuangtai', data: jjztData })
// “未解决”对应的字典值（loadSelect 异步填充 wjj，取不到时兜底为 1）
const unsolvedValue = computed(() => (jjztData.value.wjj === undefined ? 1 : jjztData.value.wjj))

const DEFAULT_PARMS = () => ({ bt: '', lx: '', jjzt: 0 })

const dataGrid = ref({
  parms: DEFAULT_PARMS(),
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'tcsj', order: 'descending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})

const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/sys/xuqiu/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      dataGrid.value.multipleSelection = []
    }
  })
}
bindTable()

// 序号跨页连续
const indexMethod = (index) => {
  const p = dataGrid.value.pagination || {}
  const pageNo = Number(p.pageNo || p.page || p.current || 1)
  const pageSize = Number(p.pageSize || p.size || 100)
  return (pageNo - 1) * pageSize + index + 1
}

// 状态标签配色
const statusType = (val) => {
  const map = { 0: 'info', 1: 'warning', 2: 'primary', 3: 'success' }
  return map[Number(val)] || 'info'
}

// 重置筛选（查看全部）
const resetSearch = () => {
  dataGrid.value.parms = {}
  treeRef.value?.setCurrentKey(null)
  xtcdMc.value = ''
  cdMc.value = ''
  addRow.value = { xtsy: 1, xtMc: '', cdMc: '', sscdmc: '' }
  bindTable()
}

const openEdit = ref(false)
const openDetail = ref(false)
const openAdd = ref(false)

// 关闭
const handleClose = () => {
  openAdd.value = false
  bindTable()
}

// 左侧菜单树
const menuCollapsed = ref(false)
const filterText = ref('')
const treeRef = ref(null)
const treeProps = { label: 'cdmc', value: 'id', children: 'children' }
watch(filterText, (val) => {
  treeRef.value?.filter(val)
})

const filterNode = (value, data) => {
  if (!value) return true
  return (data.cdmc || '').includes(value)
}

const cdData = ref([])
loadSelect({ url: '/api/v2/sys/menuquanxian/denglurencaidan', data: cdData, order: 'sx', sort: 'asc' })

// 默认展开一级菜单
const expandedKeys = computed(() => (cdData.value || []).map((item) => item.id))
watch(
  () => cdData.value,
  () => {
    nextTick(() => {
      if (dataGrid.value.parms.menuid) treeRef.value?.setCurrentKey(dataGrid.value.parms.menuid)
    })
  }
)

// 点击树形控件
const addRow = ref({})
const xtcdMc = ref('')
const cdMc = ref('')
const handleNodeClick = (node) => {
  const isTop = node.fjcdid === null || node.fjcdid === undefined || node.fjcdid === '' || node.fjcdid === 0
  const isLeaf = !node.children || node.children.length === 0
  if (isTop) {
    dataGrid.value.parms.xtid = node.id
    xtcdMc.value = node.cdmc
    dataGrid.value.parms.menuid = node.id
    cdMc.value = '首页'
  } else if (isLeaf) {
    dataGrid.value.parms.menuid = node.id
    cdMc.value = node.cdmc
  } else {
    // 中间层级：原逻辑不会切换 menuid，这里修正为跟随点击节点
    dataGrid.value.parms.menuid = node.id
    cdMc.value = node.cdmc
  }
  dataGrid.value.parms.xtsy = undefined
  addRow.value = {
    xtid: dataGrid.value.parms.xtid,
    menuid: dataGrid.value.parms.menuid,
    xtsy: dataGrid.value.parms.xtid ? undefined : 1,
    xtMc: xtcdMc.value,
    cdMc: cdMc.value,
    sscdmc: (xtcdMc.value ? xtcdMc.value + '-' : '') + (cdMc.value || '')
  }
  bindTable()
}

// 分配
const toFenPei = async (row) => {
  ElMessageBox.prompt('请输入分配给谁', '', {
    confirmButtonText: '提交',
    cancelButtonText: '取消',
    inputValue: row.jjr
  }).then(({ value }) => {
    actionPost({ url: '/api/v2/sys/xuqiu/fenpei', data: { id: row.id, jjr: value } }).then(res => {
      if (res.code === 200) {
        successPrompt(res.message)
        bindTable()
      } else {
        warningPrompt(res.message)
      }
    })
  }).catch((error) => {
    errorPrompt(error)
  })
}

// 开始（只提交变更字段，避免把整个 row 回传）
const toKaiShi = async (row) => {
  row.jjzt = 2
  actionPatch({
    url: '/api/v2/sys/xuqiu',
    data: row
  }).then(res => {
    if (res.code === 200) {
      successPrompt(res.message)
      bindTable()
    } else {
      warningPrompt(res.message)
    }
  })
}

// 解决
const toJieJue = async (row) => {
  ElMessageBox.prompt('请输入解决人', '', {
    confirmButtonText: '提交',
    cancelButtonText: '取消',
    inputValue: row.jjr
  }).then(({ value }) => {
    actionPost({ url: '/api/v2/sys/xuqiu/jiejue', data: { id: row.id, jjr: value, jjsj: getDate('YYYY', 'MM', 'DD', 'HH', 'mm') } }).then(res => {
      if (res.code === 200) {
        successPrompt(res.message)
        bindTable()
      } else {
        warningPrompt(res.message)
      }
    })
  }).catch((error) => {
    errorPrompt(error)
  })
}

// 删除
const remove = async () => {
  submitDataGridAction({
    url: '/api/v2/sys/xuqiu',
    dataGrid: dataGrid.value,
    confirmTitle: '确定要删除吗?',
    method: 'delete',
    callback: function () {
      bindTable()
    }
  })
}
</script>

<style lang="less" scoped>
.xuqiu-page {
  min-height: 0;
}

/* 左侧菜单：可展开 / 收起 */
.xuqiu-aside {
  overflow: hidden;
  background: #fff;
  border-right: 1px solid var(--el-border-color-lighter);
  transition: width 0.25s ease;

  .aside-inner {
    display: flex;
    flex-direction: column;
    width: 220px;
    height: 100%;
    box-sizing: border-box;
  }

  .aside-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 42px;
    padding: 0 8px 0 12px;
    border-bottom: 1px solid var(--el-border-color-lighter);

    .aside-title {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 14px;
      font-weight: 600;
      color: var(--el-text-color-primary);
    }

    .fold-btn {
      font-size: 16px;
      color: var(--el-text-color-secondary);

      &:hover {
        color: var(--el-color-primary);
      }
    }
  }

  .aside-body {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
    padding: 10px 8px;

    .tree-search {
      margin-bottom: 10px;
    }

    .tree-scroll {
      flex: 1;
      min-height: 0;
    }
  }
}

.tree-node {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;

  .node-icon {
    color: var(--el-color-primary-light-3);
  }

  .node-label {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

.list-page {
  padding: 0;
  padding-left: 10px;
}

.list-body {
  min-height: 0;
}

/* 搜索与工具栏 */
:deep(.search-box) {
  .w220 {
    width: 220px;
  }

  .w150 {
    width: 150px;
  }
}

.total-tip {
  margin-left: auto;
  font-size: 13px;
  color: var(--el-text-color-secondary);
}

/* 表格 */
:deep(.el-table) {
  .link-title {
    color: var(--el-color-success);
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

}
</style>
